import { useParams } from "react-router-dom";
import "./DeviceActivityLogsPage.scss";
import ActivityLogsPage from "../../../components/ActivityLogsPage/ActivityLogsPage";
import { GetCalendarDataForDeviceLogs, GetUserActivityLogsForDevice } from "../../../utils/apiCalls/logs";

const DeviceActivityLogsPage = () => {
  // Keying on the route param forces a full remount when navigating between
  // different devices' logs, so filters/pagination/date state never leak across ids.
  const { deviceName } = useParams();
  return (
    <ActivityLogsPage
      key={deviceName}
      idParam="deviceName"
      fetchLogs={GetUserActivityLogsForDevice}
      fetchCalendar={GetCalendarDataForDeviceLogs}
      backRoute="/logs"
      defaultFromTab="devices"
    />
  );
};

export default DeviceActivityLogsPage;
